import {Component, Input} from "@angular/core";
import {StandaloneFormService} from "../../services/standalone-form.service";
import {FormService} from "../../services/form.service";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";

@Component({
    selector: 'password-conditions',
    templateUrl: './password-conditions.template.html',
    styleUrls: ['./password-conditions.style.scss'],
    standalone: false
})
export class PasswordConditionsComponent {

	@Input() passwordControlName: string;
	@Input() formService: FormService;

	constructor(private translateService: TranslateService) {
	}

	conditions(): string[] {
		return this.formService.getRawErrors(StandaloneFormService.FORM_KEY, this.passwordControlName)?.filter(error => error.startsWith('password-condition'));
	}

	translate(conditionKey: string): Observable<string> {
		return this.translateService.get(`validations.${conditionKey}`);
	}
}
